module.exports = __webpack_public_path__ + "static/media/bidding.168fc3e0.png";